import React from "react";
import "./portfolio.css";
import Reveal from "../motion/Reveal";
import { motion, useReducedMotion } from "framer-motion";
import { fadeUp, stagger } from "../../motion";
import IMG1 from "../../assets/mola.png";
import IMG2 from "../../assets/questAlliance.png";
import IMG3 from "../../assets/moi.png";
import IMG4 from "../../assets/ridpestworker.png";
import IMG5 from "../../assets/ridpestcustomer.png";
import IMG6 from "../../assets/patron.png";
import IMG7 from "../../assets/patronpal.png";
import IMG8 from "../../assets/eargada.png";
import IMG9 from "../../assets/eventy.png";
import IMG10 from "../../assets/hr.png";
import IMG11 from "../../assets/eventy-engage.png";
import IMG12 from "../../assets/eventy-ocr.png";

const projects = [
  {
    id: 1,
    image: IMG11,
    title: "Eventy Engage",
    category: "Booth lead capture",
    blurb: "Show-floor companion for leads, meetings, and booth ops.",
    tags: ["React Native", "Lead capture", "Meetings", "iOS + Android"],
    appstore: "https://apps.apple.com/us/app/eventy-engage/id6788637793",
    playstore: "https://play.google.com/store/apps/details?id=com.eventy_engage.scc",
  },
  {
    id: 2,
    image: IMG12,
    title: "Eventy OCR",
    category: "Business card scanner",
    blurb: "Scan cards and documents into usable contact data on site.",
    tags: ["OCR", "Camera", "React Native", "Events"],
    appstore: "https://apps.apple.com/pk/app/eventy-ocr/id6766505563",
    playstore: "https://play.google.com/store/apps/details?id=com.eventy_ocr.scc",
  },
  {
    id: 3,
    image: IMG9,
    title: "Eventy",
    category: "Event management",
    blurb: "Events made simple — scheduling, guests, and day-of flows.",
    tags: ["Events", "Mobile", "iOS", "Android"],
    appstore: "https://apps.apple.com/us/app/eventy-events-made-simple/id6738903045",
    playstore: "https://play.google.com/store/apps/details?id=com.SCC.EventyApp",
  },
  {
    id: 4,
    image: IMG3,
    title: "Moi Gold / Aura",
    category: "Buy & sell gold",
    blurb: "India’s gold micro-investing app — buy, sell, and track live rates.",
    tags: ["Fintech", "Gold", "Mobile", "Finance"],
    appstore: "https://apps.apple.com/in/app/aura-indias-gold-saving-app/id6449191967",
    playstore: "https://play.google.com/store/apps/details?id=com.moi",
  },
  {
    id: 5,
    image: IMG2,
    title: "Quest Alliance",
    category: "Loan provider",
    blurb: "Loan provider mobile experience for applicants and operations.",
    tags: ["Fintech", "Lending", "Android"],
    playstore: "https://play.google.com/store/apps/details?id=com.org.questalliance",
  },
  {
    id: 6,
    image: IMG7,
    title: "PatronPal",
    category: "Restaurant ordering",
    blurb: "Restaurant ordering platform in the HungerStation mold.",
    tags: ["Hospitality", "Ordering", "Web"],
    web: "https://www.patronpal.com",
  },
  {
    id: 7,
    image: IMG6,
    title: "PatronWorks",
    category: "Commerce platform",
    blurb: "Cloud POS and retail workflows for modern stores.",
    tags: ["POS", "SaaS", "Retail"],
    web: "https://www.patronworks.com",
  },
  {
    id: 8,
    image: IMG1,
    title: "Mola App",
    category: "Mobile streaming",
    blurb: "High-performance streaming product for live and on-demand content.",
    tags: ["Streaming", "Mobile", "Media"],
    playstore: "https://play.google.com/store/apps/details?id=tv.mola.app",
  },
  {
    id: 9,
    image: IMG10,
    title: "Timeloop",
    category: "Attendance management",
    blurb: "Attendance tracking for teams — clock-ins, records, oversight.",
    tags: ["HR", "Attendance", "iOS", "Android"],
    appstore: "https://apps.apple.com/pk/app/timeloop-attendance/id6739751107",
    playstore: "https://play.google.com/store/apps/details?id=com.attendance.solutioncircle",
  },
  {
    id: 10,
    image: IMG10,
    title: "HR Roll",
    category: "HR management",
    blurb: "HR workflows for staff management and day-to-day operations.",
    tags: ["HR", "Mobile", "Operations"],
    appstore: "https://apps.apple.com/pk/app/hr-roll/id6737807458",
    playstore: "https://play.google.com/store/apps/details?id=com.hr_app",
  },
  {
    id: 11,
    image: IMG4,
    title: "Ridpest Worker",
    category: "Operations tool",
    blurb: "Field worker app for pest-control jobs and on-site updates.",
    tags: ["Field ops", "Android"],
    playstore: "https://play.google.com/store/apps/details?id=com.ridpestworker",
  },
  {
    id: 12,
    image: IMG5,
    title: "Ridpest Customer",
    category: "Customer app",
    blurb: "Customer-facing booking and service tracking for Ridpest.",
    tags: ["Consumer", "Android"],
    playstore: "https://play.google.com/store/apps/details?id=com.ridpest_customer",
  },
  {
    id: 13,
    image: IMG8,
    title: "Eargada",
    category: "Mobile product",
    blurb: "Consumer mobile product shipped to the Play Store.",
    tags: ["Mobile", "Product"],
    playstore: "https://play.google.com/store/apps/details?id=com.nadio",
  },
];

const Portfolio = () => {
  const reduce = useReducedMotion();

  return (
    <section id="work" className="section work">
      <div className="container">
        <Reveal>
          <p className="section__label">
            <span>02</span> — Selected work
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="section__title">Products I&apos;ve designed, built and shipped.</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="section__lead">
            {projects.length} major builds across mobile, web, and ops — the ones worth the walkthrough.
          </p>
        </Reveal>

        <motion.div
          className="work__list"
          variants={stagger(0.1)}
          initial={reduce ? false : "hidden"}
          whileInView="show"
          viewport={{ once: true, amount: 0.08 }}
        >
          {projects.map((project, index) => (
            <motion.article className="work__item" key={project.id} variants={fadeUp}>
              <div className="work__media">
                <img src={project.image} alt={project.title} />
              </div>
              <div className="work__body">
                <div className="work__top">
                  <span className="mono">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="work__category">{project.category}</span>
                </div>
                <h3>{project.title}</h3>
                <p>{project.blurb}</p>
                <ul className="work__tags">
                  {project.tags.map((tag) => (
                    <li key={tag}>{tag}</li>
                  ))}
                </ul>
                <div className="work__links">
                  {project.appstore && (
                    <a href={project.appstore} target="_blank" rel="noreferrer">
                      App Store ↗
                    </a>
                  )}
                  {project.playstore && (
                    <a href={project.playstore} target="_blank" rel="noreferrer">
                      Play Store ↗
                    </a>
                  )}
                  {project.web && (
                    <a href={project.web} target="_blank" rel="noreferrer">
                      Website ↗
                    </a>
                  )}
                </div>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Portfolio;
